
"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface NoWarrantyAlertProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function NoWarrantyAlert({ isOpen, onClose, onConfirm }: NoWarrantyAlertProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mx-auto w-fit rounded-full bg-destructive/10 p-4 mb-4">
              <AlertTriangle className="h-12 w-12 text-destructive" />
          </div>
          <AlertDialogTitle className="text-center text-2xl font-headline">Atenção: Produto Sem Garantia Extendida</AlertDialogTitle>
          <AlertDialogDescription className="text-center text-base space-y-2">
            <p>Esse produto <strong>NÃO POSSUI GARANTIA</strong> devido a quantidade de puffs do produto, ele durará até 1 dia!</p>
            <p>A garantia dele só se aplica ao funcionamento no ato da entrega e ele vai com a nossa marca para evitar fraudes na trocas.</p>
            <p className="font-bold pt-2">Ao comprar, você ACEITA OS TERMOS DE GARANTIA DESSE PRODUTO!</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center flex-col sm:flex-col sm:space-x-0">
          <AlertDialogAction onClick={onConfirm}>Estou ciente e aceito os termos</AlertDialogAction>
          <AlertDialogCancel asChild>
            <Button variant="ghost" onClick={onClose}>Voltar</Button>
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
